import { render, staticRenderFns } from "./UserFormItem.vue?vue&type=template&id=086399cd&"
import script from "./UserFormItem.vue?vue&type=script&lang=js&"
export * from "./UserFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/UserFormItem.vue"
export default component.exports